module.exports = "/_next/static/images/Quran_Osiris-09fe9bced37001f853463920ddd50cff.webp";